// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    WavesVertical,
    Waypoints,
    Webcam,
    WebcamOff,
    Webhook,
    WebhookOff,
    Weight,
    WeightTilde,
    Wheat,
    WheatOff,
    Whistle,
    WholeWord,
    Wifi,
    WifiCog,
    WifiHigh,
    WifiLow,
    WifiOff,
    WifiPen,
    WifiSync,
    WifiZero,
    Wind,
    WindArrowDown,
    Wine,
    WineOff,
    Workflow,
    Worm,
    Wrench,
    WrenchOff,
    X,
    XLineTop,
    Zap,
    ZapOff,
    ZodiacAquarius,
    ZodiacAries,
    ZodiacCancer,
    ZodiacCapricorn,
    ZodiacGemini,
    ZodiacLeo,
    ZodiacLibra,
    ZodiacOphiuchus,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "waves-vertical" through "zodiac-ophiuchus", inclusive. */
const shard: Record<string, LucideIcon> = {
    "waves-vertical": WavesVertical,
    waypoints: Waypoints,
    webcam: Webcam,
    "webcam-off": WebcamOff,
    webhook: Webhook,
    "webhook-off": WebhookOff,
    weight: Weight,
    "weight-tilde": WeightTilde,
    wheat: Wheat,
    "wheat-off": WheatOff,
    whistle: Whistle,
    "whole-word": WholeWord,
    wifi: Wifi,
    "wifi-cog": WifiCog,
    "wifi-high": WifiHigh,
    "wifi-low": WifiLow,
    "wifi-off": WifiOff,
    "wifi-pen": WifiPen,
    "wifi-sync": WifiSync,
    "wifi-zero": WifiZero,
    wind: Wind,
    "wind-arrow-down": WindArrowDown,
    wine: Wine,
    "wine-off": WineOff,
    workflow: Workflow,
    worm: Worm,
    wrench: Wrench,
    "wrench-off": WrenchOff,
    x: X,
    "x-line-top": XLineTop,
    zap: Zap,
    "zap-off": ZapOff,
    "zodiac-aquarius": ZodiacAquarius,
    "zodiac-aries": ZodiacAries,
    "zodiac-cancer": ZodiacCancer,
    "zodiac-capricorn": ZodiacCapricorn,
    "zodiac-gemini": ZodiacGemini,
    "zodiac-leo": ZodiacLeo,
    "zodiac-libra": ZodiacLibra,
    "zodiac-ophiuchus": ZodiacOphiuchus,
};

export default shard;
